
export default {
  valueType: 'inputSearch',
  FormItemProps: {
    label: '搜索输入框',
    rules: [],
  },
  btnAttr: {
    enterButtonText: "搜索",
    onClick: null,
    loading: false,
  },
  ControlProps: {
    placeholder: "",
    disabled: false,
    style: {}
  }
}

